import React, { useState, useContext } from "react";
import _ from "lodash";
import { Row, Form, Modal } from "react-bootstrap";
import AddIcon from "@material-ui/icons/Add";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { UserContext } from "../../context/UserContext";
import { Chip, Tooltip } from "@material-ui/core";
import "../../styles/form.scss";
import {StyledBlackButton, StyledBlueButton} from "../../styles/BootstrapStyles";
import useStateRef from "../../hooks/useStateRef";

const ModalView = ({ item, onComplete, onClose, show, mode }) => {
  const [dept, setDepartment] = useState(_.get(item, "Department", ""));
  const { department } = useContext(UserContext);
  const [value, setValue] = useState("");
  const [onValue, setCValue] = useStateRef("");
  const [error, setError] = useState(null);

  const getUniqueDepartment = (newDept = value) => {
    const existingDept = department.find(element => element.toLowerCase() === newDept.trim().toLowerCase());
    return _.uniqBy(_.concat(dept, existingDept ? existingDept : newDept.trim()), _.toLower);
  }

  return (
    <Modal className="modal"
           backdrop="static"
           onHide={onClose}
           show={show}
           dialogClassName="modalDialog">
      {mode === "admin" ? (
        <>
          <Modal.Header className="modalHeader" closeButton={true} onHide={onClose}>
            <Modal.Title className="modalHeaderTitle">Edit user {_.get(item, "SAMAccountName")}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="modalBody">
            <Autocomplete
              disableClearable
              freeSolo
              className="formAutoComplete"
              classes={{
                inputRoot: "formAutoCompleteRoot",
                input: "formAutoCompleteInput",
                listbox: "formList",
                option: "formAutoCompleteOption",
                popper: "formAutoCompletePopper"
              }}
              inputValue={value}
              value={onValue}
              onKeyDown={(e) => {
                if (["Enter"].includes(e.key) && !_.isEmpty(value)) {
                  e.preventDefault();
                  setDepartment(getUniqueDepartment());
                  setValue("");
                  setError(null);
                }
              }}
              onChange={(e, newValue) => {
                setValue("");
                setCValue("");
                setError(null);
                let currentValue = getUniqueDepartment(newValue);
                setDepartment(currentValue);
              }}
              open={!_.isEmpty(value)}
              options={_.map(department, (option) => _.toString(option))}
              renderInput={(params) => (
                <TextField
                  error={Boolean(error)}
                  {...params}
                  value={value}
                  onChange={(e) => {
                    setValue(e.target.value);
                    setError(null);
                  }}
                  id="textField"
                  variant="outlined"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <AddIcon
                        className="modalViewIcon"
                        onClick={(e) => {
                          if (!_.isEmpty(value)) {
                            setDepartment(getUniqueDepartment());
                            setValue("");
                          }
                        }}
                      />
                    ),
                  }}
                  required={_.isEmpty(dept)}
                  placeholder={"Add Department"}
                />
              )}
            />
            <div style={{ margin: "10px 0px" }}>
              {_.map(dept, (option, index) => {
                return (
                  <span
                    style={{
                      marginLeft: "10px",
                      marginTop: "5px",
                      marginRight: "5px",
                    }}
                    key={index}>
                    <Tooltip
                      title={"Make primary"}
                      interactive
                      placement="bottom"
                      arrow
                      disableHoverListener={index === 0 ? true : false}>
                      <Chip
                        label={option}
                        key={index}
                        onClick={(e) => {
                          if (index !== 0) {
                            let deptIndex = _.indexOf(dept, option);
                            let currentDepartments = dept;
                            let newDepartments = currentDepartments.slice(0);
                            let primaryDept = newDepartments.splice(deptIndex, 1);
                            setDepartment(primaryDept.concat(newDepartments));
                          }
                        }}
                        style={{
                          marginTop: "5px",
                          marginBottom: "5px",
                          overflow: "auto",
                          background: index === 0 ? "#99de99" : "#e0e0e0",
                        }}
                        onDelete={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setDepartment(dept.filter((entry) => entry !== option));
                        }}
                      />
                    </Tooltip>
                  </span>
                );
              })}
            </div>
            <Row style={{ justifyContent: "flex-end" }} className="m-0">
              <StyledBlueButton
                onClick={(e) => {
                  e.preventDefault();
                  let deptN={sAMAccountName:_.get(item,"SAMAccountName"),uid:_.get(item,"SAMAccountName")};
                  if (!_.isEmpty(dept) && !_.isEqual(dept, _.get(item, "Department"))) {
                    deptN["deptName"]=dept;
                    onComplete(_.get(item, "ID"), deptN);
                  } else if (!_.isEmpty(value)) {
                    deptN["deptName"] = getUniqueDepartment();
                    onComplete(_.get(item, "ID"), deptN );
                  } else if (_.isEqual(dept, _.get(item, "Department")) && !_.isEmpty(dept)) {
                    onClose();
                  } else {
                    setError("User has atleast one department");
                  }
                }}>
                Save
              </StyledBlueButton>
              <StyledBlackButton
                onClick={(e) => {
                  e.preventDefault();
                  onClose(e);
                }}>
                Cancel
              </StyledBlackButton>
            </Row>
          </Modal.Body>
        </>
      ) : (
        <>
          <Modal.Header className="modalHeader" closeButton={true} onHide={onClose}>
            <Modal.Title className="modalHeaderTitle">Edit Item</Modal.Title>
          </Modal.Header>
          <Modal.Body className="modalBody">
            <Form
              key={_.get(item, "_id")}
              onSubmit={(e) => {
                e.preventDefault();
                let newItem = { ...item };
                onComplete(Object.assign(_.omit(newItem, "griddleKey"), { name: _.get(e.target, "editField.value") }));
              }}>
              <Form.Group controlId="editField">
                <Form.Control
                  className="modalViewInputDescription"
                  defaultValue={_.get(item, "name")}
                  required={true}
                  placeholder="Item Name"
                />
              </Form.Group>
              <Row style={{ justifyContent: "flex-end" }} className="m-0">
                <StyledBlueButton type="submit">
                  Save
                </StyledBlueButton>
                <StyledBlackButton
                  onClick={(e) => {
                    e.preventDefault();
                    onClose(e);
                  }}>
                  Cancel
                </StyledBlackButton>
              </Row>
            </Form>
          </Modal.Body>
        </>
      )}
    </Modal>
  );
};
ModalView.defaultProps = { item: "", onComplete: () => {}, onClose: () => {}, show: false, mode: "" };

export default ModalView;
